import fetchService from 'common/actions/fetchService';

export const PAX_MANIFEST_UPDATE_MARKED_PASSENGERS =
  'PAX_MANIFEST_UPDATE_MARKED_PASSENGERS';
export default function updateMarkedPassengersAction(spec) {
  return function thunk(dispatch, getState) {
    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetoperator/manifest/mark',
          spec
        )
      )
    ).then(({ result }) => {
      dispatch({
        type: PAX_MANIFEST_UPDATE_MARKED_PASSENGERS,
        payload: result.data,
      });
      return result.data;
    });
  };
}
